<template>
  <div class="articleContent">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/industry-manage' }"
        >行业监管</el-breadcrumb-item
      >
      <el-breadcrumb-item>监管事项目录清单</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="line-height: 26px; text-align: left; margin: 5px 0">
      <span class="card-title-line"></span>
      <span class="card-title-word">{{ title }}</span>
    </div>
    <div v-show="this.$route.query.judge == 1">
      <mailTable :tableData="regulMatter" :showByRow="regulOne"></mailTable>
      <span class="spn"></span>
      <mailTable :tableData="regulMatterOne" :showByRow="regulTwo"></mailTable>
      <span class="spn"></span>
      <table class="mailTable" v-show="regulShow">
        <tr v-for="(item, index) in regulMatterTwo" :key="index">
          <td class="column">
            {{ item.key }}
          </td>
          <td class="row" v-html="item.value"></td>
        </tr>
      </table>
    </div>
    <div v-show="this.$route.query.judge == 0">
      <mailTable :tableData="supervisionOne" :showByRow="regulOne"></mailTable>
      <span class="spn"></span>
      <mailTable :tableData="supervisionTwo" :showByRow="regulTwo"></mailTable>
    </div>
  </div>
</template>
<script>
import mailTable from "../../components/Table/tableCompontent";
import {
  URL_FINDREGULATORY_ONE,
  URL_SELECTALLBYREGULATORYLOCALID,
} from "../../utils/api";
import util from "../../utils/util";
import { frontHeater } from "../../utils/md5encryption";
export default {
  props: [],
  components: { mailTable },
  data() {
    return {
      // 标题  query获取替换
      title: null,
      // 监管事项表格
      regulOne: false,
      regulTwo: false,
      dataList: [],
      regulMatter: [
        {
          key: "监管事项",
          value: "",
        },
        {
          key: "监管部门",
          value: "",
        },
        {
          key: "对应的许可事项名称",
          value: "",
        },
        {
          key: "对应的许可事项类型",
          value: "",
        },
      ],
      // 监管事项表格one
      regulMatterOne: [
        {
          key: "监管事项子项",
          value: "",
        },
        {
          key: "监管对象",
          value: "",
        },
        {
          key: "监管形式",
          value: "",
        },
        {
          key: "监管方式",
          value: "",
        },
        {
          key: "设定依据",
          value: "",
        },
        {
          key: "监管流程",
          value: "",
        },
        {
          key: "监管结果",
          value: "",
        },
        {
          key: "监管层级",
          value: "",
        },
      ],
      // 监管事项表格two
      regulMatterTwo: [
        {
          key: "监管事项子项",
          value: "",
        },
        {
          key: "监管对象",
          value: "",
        },
        {
          key: "监管形式",
          value: "",
        },
        {
          key: "监管方式",
          value: "",
        },
        {
          key: "设定依据",
          value: "",
        },
        {
          key: "监管流程",
          value: "",
        },
        {
          key: "监管结果",
          value: "",
        },
        {
          key: "监管层级",
          value: "",
        },
      ],
      //  子项表2显示与隐藏
      regulShow: false,
      // 本级监管表格
      supervisionOne: [
        {
          key: "监管事项",
          value: "",
        },
        {
          key: "行使层级",
          value: "",
        },
        {
          key: "监管事项检查实施清单编码",
          value: "",
        },
        {
          key: "监管事项目录编码",
          value: "",
        },
        {
          key: "实施主体名称",
          value: "",
        },
        {
          key: "实施主体编码",
          value: "",
        },
        {
          key: "实施主体性质",
          value: "",
        },
        {
          key: "受委托部门名称",
          value: "",
        },
        {
          key: "受委托部门编码",
          value: "",
        },
        {
          key: "监管对象主项",
          value: "",
        },
      ],
      supervisionTwo: [
        {
          key: "监管对象子项",
          value: "",
        },
        {
          key: "是否纳入双随机",
          value: "",
        },
        {
          key: "检查比例",
          value: "",
        },
        {
          key: "检查频次",
          value: "",
        },
        {
          key: "是否抽检",
          value: "",
        },
        {
          key: "检查内容(日常)",
          value: "",
        },
        {
          key: "检查内容(专项)",
          value: "",
        },
        {
          key: "监督抽检内容(日常)",
          value: "",
        },
        {
          key: "是否协同",
          value: "",
        },
        {
          key: "协同相关机构",
          value: "",
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.title = this.$route.query.title;
    if (this.$route.query.judge == 1) {
      this.getList();
    } else {
      setTimeout(() => {
        this.getBenList();
      }, 100);
    }
  },
  methods: {
    //获取列表数据
    getList() {
      let result = frontHeater([""], [""]);
      let Url = util.getAjaxUrl("axiosThree");
      let params = {
        subitemItem: this.$route.query.title,
      };

      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;

      this.$http.post(Url + URL_FINDREGULATORY_ONE, params).then((res) => {
        if (res.status == 200) {
          this.regulMatter[0].value = res.data.data[0].subitemItem;
          this.regulMatter[1].value = res.data.data[0].department;
          this.regulMatter[2].value = res.data.data[0].permitItem;
          this.regulMatter[3].value = res.data.data[0].permitType;
          this.regulMatterOne[0].value = res.data.data[0].subitemName;
          this.regulMatterOne[1].value = res.data.data[0].superviseObject;
          this.regulMatterOne[2].value = res.data.data[0].superviseForm.replace(
            /\^p|\^P/g,
            "<br/>"
          );
          this.regulMatterOne[3].value = res.data.data[0].superviseWay;
          this.regulMatterOne[4].value = res.data.data[0].setGist.replace(
            /\^p|\^P/g,
            "<br/>"
          );
          this.regulMatterOne[5].value = res.data.data[0].superviseFlow.replace(
            /\^p|\^P/g,
            "<br/>"
          );
          this.regulMatterOne[6].value =
            res.data.data[0].superviseResult.replace(/\^p|\^P/g, "<br/>");
          this.regulMatterOne[7].value =
            res.data.data[0].superviseLevel.replace(/\^p|\^P/g, "<br/>");
          if (res.data.data[1] !== undefined) {
            this.regulShow = true;
            this.regulMatterTwo[0].value = res.data.data[1].subitemName;
            this.regulMatterTwo[1].value = res.data.data[1].superviseObject;
            this.regulMatterTwo[2].value = res.data.data[1].superviseForm;
            this.regulMatterTwo[3].value = res.data.data[1].superviseWay;
            this.regulMatterTwo[4].value = res.data.data[1].setGist.replace(
              /\^p|\^P/g,
              "<br/>"
            );
            this.regulMatterTwo[5].value =
              res.data.data[1].superviseFlow.replace(/\^p|\^P/g, "<br/>");
            this.regulMatterTwo[6].value = res.data.data[1].superviseResult;
            this.regulMatterTwo[7].value = res.data.data[1].superviseLevel;
          } else {
            this.regulShow = false;
          }
        }
      });
    },
    //获取本级列表
    getBenList() {
      let result = frontHeater(["regulatoryLocalId"], [this.$route.query.id]);
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["regulatoryLocalId"] =
        this.$route.query.id;
      let Url = util.getAjaxUrl("axiosThree");
      let params = {
        regulatoryLocalId: this.$route.query.id,
      };
      this.$http
        .get(Url + URL_SELECTALLBYREGULATORYLOCALID, { params })
        .then((res) => {
          if (res.status == 200) {
            this.supervisionOne[0].value = this.title;
            this.supervisionOne[1].value = res.data.data.exerciseLevel;
            this.supervisionOne[2].value = res.data.data.subitemItemCode;
            this.supervisionOne[3].value = res.data.data.subitemItemCode;
            this.supervisionOne[4].value = res.data.data.implementBody;
            this.supervisionOne[5].value = res.data.data.implementBodyCode;
            this.supervisionOne[6].value = res.data.data.implementNature;
            this.supervisionOne[7].value = res.data.data.delegationDepartment;
            this.supervisionOne[8].value = res.data.data.delegationDepCode;
            this.supervisionOne[9].value = res.data.data.supervisionObject;
            this.supervisionTwo[0].value = res.data.data.supervisionObjectSub;
            this.supervisionTwo[1].value = res.data.data.isRandom;
            this.supervisionTwo[2].value = res.data.data.checkProportion;
            this.supervisionTwo[3].value = res.data.data.checkFrequency;
            this.supervisionTwo[4].value = res.data.data.supervisionContent;
            this.supervisionTwo[5].value = res.data.data.dailyList.replace(
              /\^p|\^P/g,
              "<br/>"
            );
            this.supervisionTwo[6].value = res.data.data.specialList.replace(
              /\^p|\^P/g,
              "<br/>"
            );
            this.supervisionTwo[7].value = res.data.data.samplingList.replace(
              /\^p|\^P/g,
              "<br/>"
            );
            this.supervisionTwo[8].value = res.data.data.isSynergy;
            this.supervisionTwo[9].value = res.data.data.synergyDep;
          }
        });
    },
  },
};
</script>
<style scoped lang='less'>
@import "../../styles/base";
@import "../../styles/comSty";
.spn {
  display: inline-block;
}
　　.mailTable,
.mailTable tr,
.mailTable tr td {
  border: 1px solid #606266;
}
　　.mailTable {
  font-size: 14px;
  color: #606266;
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
}
　　.mailTable tr td {
  border: 1px solid #606266;
  height: 40px;
  box-sizing: border-box;
  line-height: 20px;
  padding: 10px;
}
　.column {
  text-align: center;
  background-color: #ebe6db;
  color: #393c3e;
  width: 150px;
}
.row {
  color: #393c3e;
  text-align: left;
  word-break: break-all;
  word-wrap: break-word;
}
</style>